<template>
	<auth-shell>
		<h1 class="auth-title">Forgot your password?</h1>
		<p class="auth-subtitle">
			Enter the email associated with your account and we'll send you a secure link to reset it.
		</p>

		<div v-if="info" class="auth-alert">{{ info }}</div>

		<form @submit.prevent="sendResetPasswordLink">
			<div class="auth-field">
				<label class="auth-label" for="email">Email</label>
				<div class="auth-input-group">
					<font-awesome-icon class="auth-input-icon" :icon="['fas', 'envelope']" />
					<input id="email" type="email" class="auth-input" placeholder="you@townweb.com,you@heygov.com" autocomplete="email" v-model="email" required />
				</div>
			</div>

			<button v-if="!loading" type="submit" class="auth-btn">
				Send reset link
				<font-awesome-icon :icon="['fas', 'arrow-right']" />
			</button>
			<button v-else type="button" class="auth-btn" disabled>
				<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
				Sending reset link…
			</button>
		</form>

		<div class="auth-switch">
			<router-link class="auth-link" to="/login"> <font-awesome-icon :icon="['fas', 'arrow-left']" /> Back to sign in </router-link>
		</div>
	</auth-shell>
</template>
<script>
import AuthShell from '../../components/auth/AuthShell.vue'
import restApi from '../../api'
import { handleErrors } from '../../actions/helpers'
export default {
	name: 'ForgotPassword',
	components: { AuthShell },
	data() {
		return {
			info: '',
			email: '',
			loading: false,
		}
	},
	methods: {
		async sendResetPasswordLink() {
			this.loading = true
			restApi.post(`/forgot-password`, { email: this.email }).then(
				({ data }) => {
					this.info = data.message
					this.loading = false
				},
				error => {
					this.info = ''
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, 'forgotPassword'),
						timer: 6000,
					})
					this.loading = false
				}
			)
		},
	},
}
</script>
